import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ZoningCode, ZoningCodeVersion } from 'src/app/modules/instance/models';
import { ZoningCodeService, ZoningCodeVersionService } from 'src/app/modules/instance/services';

@Component({
    standalone: false,
    selector: 'app-zc-version-select-subform',
    templateUrl: './zc-version-select-subform.component.html',
    styleUrls: ['./zc-version-select-subform.component.scss']
})
export class ZcVersionSelectSubformComponent implements OnInit {
    @Output()
    formReady = new EventEmitter<FormGroup>();
    zcVersions: ZoningCodeVersion[] = [];
    zcvForm: FormGroup;
    zoningCodes: Array<ZoningCode>;

    selectedAll: boolean;

    constructor(
        private formBuilder: FormBuilder,
        private readonly zcvService: ZoningCodeVersionService,
        private readonly zcService: ZoningCodeService
    ) {}

    get hasZCVersions() {
        return this.zcVersions && !!this.zcVersions.length;
    }

    static getQueryParams(formGroup: any): any {
        return {
            selectedZCVersionId: formGroup['selectedZCVersion'] && formGroup['selectedZCVersion'].Id
        };
    }

    onChange(zoningCode: ZoningCode) {
        this.zcvService.getVersionsForZoningCode(zoningCode).subscribe(zcVersions => {
            this.zcVersions = zcVersions;
            this.hasZCVersions
                ? this.zcvForm.get('selectedZCVersion').enable()
                : this.zcvForm.get('selectedZCVersion').disable();
        });
    }

    ngOnInit() {
        this.zoningCodes = this.zcService.lastZoningCodesValue;
        this.zcvForm = this.formBuilder.group({
            selectedZCVersion: '',
            zoningCode: ''
        });
        this.formReady.emit(this.zcvForm);
        this.zcvForm.get('selectedZCVersion').disable();
    }
}
